module.exports = __webpack_public_path__ + "fonts/font.0834562.woff";